"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Hitagi_Plugin_Status {
    constructor(HitagiInstance) {
        this.hitagi = HitagiInstance;
    }
    rooms_list(Success, Error) {
        const Packet = {
            "plugin": "status",
            "action": "rooms_list",
            "args": {}
        };
        this.hitagi.send(Packet, Success, Error);
    }
    people_in_room(Room, Success, Error) {
        const Packet = {
            "plugin": "status",
            "action": "people_in_room",
            "args": { "room": Room }
        };
        this.hitagi.send(Packet, Success, Error);
    }
    version(Success, Error) {
        this.hitagi.action("status", "version", {}, Success, Error);
    }
    callback__motd(Args) {
        this.hitagi.fire_event("status:motd", Args);
    }
    callback__caps_change(Args) {
        this.hitagi.capabilities.mass_change(Args.caps);
    }
}
exports.default = Hitagi_Plugin_Status;
